var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-container",on:{"click":function($event){return _vm.$emit('changed')}}},[(!_vm.status)?_c('div',{staticClass:"off-item"}):_vm._e(),(_vm.status)?_c('div',{staticClass:"on-item"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }